import { IContractEmailsRepository } from 'modules/customer/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisContractEmailsRepository
  implements IContractEmailsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public create: IContractEmailsRepository['create'] = async ({
    customerId,
    contractId,
  }) => {
    return this.httpProvider.post(
      `/area-cliente/financeiro/${customerId}/contrato/${contractId}/envio-contrato-email`,
    );
  };
}
